import { ToolsHeadingEnum } from "./tools-heading-models";
import { ToolsRoutingConstants } from "./tool-routing.constants";
export const ToolsLinkMap = new Map([
    [ToolsHeadingEnum.Report, ToolsRoutingConstants.REPORT_ROUTE],
    [ToolsHeadingEnum.ReportSchedule, ToolsRoutingConstants.REPORT_SCHEDULE_ROUTE],
    [ToolsHeadingEnum.ViewMap, ToolsRoutingConstants.VIEWMAP_ROUTE],
]);
